import { AfterViewChecked, Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
  selector: '[sizeMatch]'
})
export class SizeMatchDirective implements AfterViewChecked {
  @Input() sizeMatch: string = 'height';

  constructor(private el: ElementRef) { }

  ngAfterViewChecked() {
    this.matchSize(this.el.nativeElement);
  }

  @HostListener('window:resize')
  onResize() {
    this.matchSize(this.el.nativeElement);
  }

  matchSize(parent: HTMLElement) {
    if (!parent) { return; }
    let height = parent.getBoundingClientRect().height;
    let width = parent.getBoundingClientRect().width;

    if (this.sizeMatch === 'height') {
      parent.style.height = `${width}px`;
    } else {
      parent.style.width = `${height}px`;
    }
  }
}
